const STORAGE_KEY = 'clientType'
const LANGUAGE_STORAGE_KEY = 'clientLanguage'
const DEFAULT_CLIENT = 'travis'
const VALID_CLIENTS = ['travis', 'mrowka', 'toolstation']
const VALID_LANGUAGES = ['pl', 'en']

export const getClientType = () => {
  const urlParams = new URLSearchParams(window.location.search)
  const typeFromUrl = urlParams.get('type')

  if (typeFromUrl && VALID_CLIENTS.includes(typeFromUrl)) {
    localStorage.setItem(STORAGE_KEY, typeFromUrl)
    return typeFromUrl
  }

  const storedType = localStorage.getItem(STORAGE_KEY)
  if (storedType && VALID_CLIENTS.includes(storedType)) {
    return storedType
  }

  return DEFAULT_CLIENT
}

export const getLanguageOverride = () => {
  const urlParams = new URLSearchParams(window.location.search)
  const langFromUrl = urlParams.get('language')

  if (langFromUrl && VALID_LANGUAGES.includes(langFromUrl)) {
    localStorage.setItem(LANGUAGE_STORAGE_KEY, langFromUrl)
    return langFromUrl
  }

  const storedLanguage = localStorage.getItem(LANGUAGE_STORAGE_KEY)
  if (storedLanguage && VALID_LANGUAGES.includes(storedLanguage)) {
    return storedLanguage
  }

  return null
}

export const setClientType = (type) => {
  if (VALID_CLIENTS.includes(type)) {
    localStorage.setItem(STORAGE_KEY, type)
  }
}

export const clearClientType = () => {
  localStorage.removeItem(STORAGE_KEY)
}